// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__odEsf","name":"styles_name__1Xwji","phone":"styles_phone__1iFh7"};